import { select, put, takeLatest } from 'redux-saga/effects'
import { getHomeSelector } from '../selectors/getHome.selector'
import { setIncompleteFilter } from '../store/home.actions'
import { HomeConstants } from '../store/home.constants'
import { IHomeState } from '../store/home.types'

export function* inCompleteStatusFilter() {
  const state: IHomeState = yield select(getHomeSelector)
  const { pcrDocs, filter } = state
  const { completeFilterOn, incompleteFilterOn, needsReviewFilterOn } = filter
  const filters: string[] = []
  completeFilterOn && filters.push('Complete')
  needsReviewFilterOn && filters.push('Needs Review')
  const showClearFiltersButton = completeFilterOn || needsReviewFilterOn || !incompleteFilterOn
  if (incompleteFilterOn) {
    if (filters && filters.length) {
      const filteredPCRDocs = pcrDocs.filter((pcrDoc) => filters.indexOf(pcrDoc.status) > -1)
      yield put(setIncompleteFilter(filteredPCRDocs, showClearFiltersButton))
    } else {
      yield put(setIncompleteFilter(pcrDocs, showClearFiltersButton))
    }
  } else {
    const filteredPCRDocs = state.pcrDocs.filter(
      (pcrDoc) => pcrDoc.status === 'Incomplete' || filters.indexOf(pcrDoc.status) > -1
    )
    yield put(setIncompleteFilter(filteredPCRDocs, showClearFiltersButton))
  }
}

export function* inCompleteStatusFilterSaga() {
  yield takeLatest([HomeConstants.FILTER_INCOMPLETE], inCompleteStatusFilter)
}
